import React from 'react';
import { CartesianGrid, Label, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { mapChartColor } from 'components/forecast/forecastCharts/charts-color-mapper';
import { ChartInput } from 'components/forecast/forecastCharts/chart-input-selector';
import { autoFormatValue } from 'lib/value-formatter';

export function AppLineChart(props: { input: ChartInput }) {
  const input = props.input;
  const chart = props.input.chart;
  const data = props.input.data;

  const tooltipFormatter = (value: string, name: string, props: any) => {
    return valueFormatter(Number.parseFloat(value));
  };

  const valueFormatter = (value: number) => autoFormatValue(value);

  const isPrintView = props.input.isPrintView;
  const isAnimationActive = !isPrintView;

  return <ResponsiveContainer height="100%" width="99%">
    <LineChart
      data={data}
    >
      <CartesianGrid
        strokeDasharray="4 4"
      />
      <XAxis
        dataKey={chart?.xAxisId}
        fontSize={input.axisFontSize}
        height={60}
      >
        <Label
          value={chart?.xAxisLabel}
          position="insideBottom"
          offset={3}
          style={{ color: '#555555' }}
          fontSize={input.axisFontSize}
          height={80}
        />
      </XAxis>
      <YAxis
        tickFormatter={valueFormatter}
        fontSize={input.axisFontSize}
        offset={-3}
        width={120}
      />
      <Legend
        verticalAlign="top"
        height={50}
        fontSize={input.axisFontSize}
        iconSize={20}
      />
      {
        !isPrintView &&
        <Tooltip
          formatter={tooltipFormatter}
          isAnimationActive={false}
        />
      }
      {
        chart && chart.dataSeries.map((ds, n) =>
          <Line
            key={n}
            name={ds.name}
            type="linear"
            dataKey={ds.id}
            stroke={mapChartColor(ds.color)}
            strokeWidth={isPrintView ? 2 : 4}
            isAnimationActive={isAnimationActive}
          />,
        )
      }
    </LineChart>
  </ResponsiveContainer>;
}

export default AppLineChart;
